import { useQuery } from "react-query";
import { GET_LOCATIONS_BY_ID } from "shared-services";
import locationService from "../services/location";

export function useGetLocations(
  locationIds: string[],
  enabled: boolean = true
) {
  return useQuery(
    [GET_LOCATIONS_BY_ID, locationIds],
    () => locationService.getGoogleLocationsByIds(locationIds),
    {
      enabled,
    }
  );
}
